module.exports = __webpack_public_path__ + "images/141_160.jpg";